import { isDianpingAppOrWebview, getPlatformType, PlatformType } from '@nibfe/mkt-env-api';
import { appendImageWidth, convertToHttps, getRealImageSource } from './image-utils';
// 客户端类型
export var CLIENT_TYPE;
(function (CLIENT_TYPE) {
    CLIENT_TYPE["MT_MRN"] = "MT_MRN";
    // 美团 MRN
    CLIENT_TYPE["DP_MRN"] = "DP_MRN";
    // 点评 MRN
    CLIENT_TYPE["HOTEL_MINIAPP"] = "HOTEL_MINIAPP";
    // 酒店+小程序
    CLIENT_TYPE["MT_MINIAPP"] = "MT_MINIAPP";
    // 美团小程序
    CLIENT_TYPE["DP_MINIAPP"] = "DP_MINIAPP"; // 点评小程序
})(CLIENT_TYPE || (CLIENT_TYPE = {}));
// 页面类型
export var SUPER_GROUP_PAGE;
(function (SUPER_GROUP_PAGE) {
    SUPER_GROUP_PAGE["GOODS_DETAIL"] = "GOODS_DETAIL";
    // 商品详情页
    SUPER_GROUP_PAGE["ORDER_DETAIL"] = "ORDER_DETAIL";
    // 订单详情页
    SUPER_GROUP_PAGE["EXCHANGE_LIST"] = "EXCHANGE_LIST";
    // 兑换列表页
    SUPER_GROUP_PAGE["CALENDAR"] = "CALENDAR"; // 房型日历页
})(SUPER_GROUP_PAGE || (SUPER_GROUP_PAGE = {}));
// URL 模板
export const SUPER_GROUP_URL_TEMPLATE = {
    [CLIENT_TYPE.MT_MRN]: {
        [SUPER_GROUP_PAGE.GOODS_DETAIL]: 'imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=superdeal&mrn_component=superdeal&mboxCouponId={mboxCouponId}&spuId={spuId}',
        [SUPER_GROUP_PAGE.ORDER_DETAIL]: 'imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=hotel-super-group-order-detail&mrn_component=max_hotelchannel-super-group-order-detail&id={orderId}',
        [SUPER_GROUP_PAGE.EXCHANGE_LIST]: 'imeituan://www.meituan.com/mrn?applyId={applyId}&mrn_biz=hotel&mrn_entry=super-group-exchange&spuId={spuId}&giftCardCode={giftCardCode}&mrn_component=max-super-group-exchange',
        [SUPER_GROUP_PAGE.CALENDAR]: 'imeituan://www.meituan.com/mrn?mrn_min_version=0.16.0&applyId={applyId}&mrn_biz=hotel&mrn_entry=max-superdeal-goods-calendar&spuId={spuId}&giftCardCode={giftCardCode}&mrn_component=max-superdeal-goods-calendar'
    },
    [CLIENT_TYPE.DP_MRN]: {
        [SUPER_GROUP_PAGE.GOODS_DETAIL]: 'dianping://mrn?mrn_biz=hotel&mrn_entry=superdeal&mrn_component=superdeal&mboxCouponId={mboxCouponId}&spuId={spuId}',
        [SUPER_GROUP_PAGE.ORDER_DETAIL]: 'dianping://mrn?mrn_biz=hotel&mrn_entry=hotel-super-group-order-detail&mrn_component=max_hotelchannel-super-group-order-detail&id={orderId}',
        [SUPER_GROUP_PAGE.EXCHANGE_LIST]: 'dianping://mrn?applyId={applyId}&mrn_biz=hotel&mrn_entry=super-group-exchange&spuId={spuId}&giftCardCode={giftCardCode}&mrn_component=max-super-group-exchange',
        [SUPER_GROUP_PAGE.CALENDAR]: 'dianping://mrn?mrn_min_version=0.16.0&applyId={applyId}&mrn_biz=hotel&mrn_entry=max-superdeal-goods-calendar&spuId={spuId}&giftCardCode={giftCardCode}&mrn_component=max-superdeal-goods-calendar'
    },
    [CLIENT_TYPE.HOTEL_MINIAPP]: {
        [SUPER_GROUP_PAGE.GOODS_DETAIL]: '/pages/superGroup/index?mboxCouponId={mboxCouponId}&spuId={spuId}',
        [SUPER_GROUP_PAGE.ORDER_DETAIL]: 'https://awp.meituan.com/nibfe/hotel-fe-max/super-group-order-detail/web/index.html?id={orderId}',
        [SUPER_GROUP_PAGE.EXCHANGE_LIST]: 'https://awp.meituan.com/hfe/max-super-group-exchange/web/index.html?applyId={applyId}&spuId={spuId}&giftCardCode={giftCardCode}',
        [SUPER_GROUP_PAGE.CALENDAR]: 'https://awp.meituan.com/nibfe/hotel-fe-max/superdeal-goods-calendar/web/index.html?applyId={applyId}&spuId={spuId}&giftCardCode={giftCardCode}'
    },
    [CLIENT_TYPE.MT_MINIAPP]: {
        [SUPER_GROUP_PAGE.GOODS_DETAIL]: '/hotel/pages/superGroup/index?mboxCouponId={mboxCouponId}&spuId={spuId}',
        [SUPER_GROUP_PAGE.ORDER_DETAIL]: 'https://awp.meituan.com/nibfe/hotel-fe-max/super-group-order-detail/web/index.html?id={orderId}',
        [SUPER_GROUP_PAGE.EXCHANGE_LIST]: 'https://awp.meituan.com/hfe/max-super-group-exchange/web/index.html?applyId={applyId}&spuId={spuId}&giftCardCode={giftCardCode}',
        [SUPER_GROUP_PAGE.CALENDAR]: 'https://awp.meituan.com/nibfe/hotel-fe-max/superdeal-goods-calendar/web/index.html?applyId={applyId}&spuId={spuId}&giftCardCode={giftCardCode}'
    },
    [CLIENT_TYPE.DP_MINIAPP]: {
        [SUPER_GROUP_PAGE.GOODS_DETAIL]: '/packages/hotel/pages/superGroup/index?mboxCouponId={mboxCouponId}&spuId={spuId}',
        [SUPER_GROUP_PAGE.ORDER_DETAIL]: '/packages/hotel/pages/h5/index?q=${encodeURIComponent("https://awp.meituan.com/nibfe/hotel-fe-max/super-group-order-detail/web/index.html?id={orderId}")}',
        [SUPER_GROUP_PAGE.EXCHANGE_LIST]: '/packages/hotel/pages/h5/index?q=${encodeURIComponent("https://awp.meituan.com/hfe/max-super-group-exchange/web/index.html?applyId={applyId}&spuId={spuId}&giftCardCode={giftCardCode}")}',
        [SUPER_GROUP_PAGE.CALENDAR]: '/packages/hotel/pages/h5/index?q=${encodeURIComponent("https://awp.meituan.com/nibfe/hotel-fe-max/superdeal-goods-calendar/web/index.html?applyId={applyId}&spuId={spuId}&giftCardCode={giftCardCode}")}'
    }
};
function getExtraButtonText(isSpuHot, targetOrderCnt, salesCount) {
    if (!isSpuHot && targetOrderCnt > 0 && targetOrderCnt < 100) {
        return `仅差${targetOrderCnt}单`;
    }
    if (!isSpuHot && targetOrderCnt >= 100 && salesCount) {
        return `已售${getSaleCountStr(salesCount)}`;
    }
    return '';
}
function getPromotionText(isSpuHot, originalPrice, sellPrice, salesCount) {
    const priceDiff = originalPrice - sellPrice;
    if (!isSpuHot) {
        return priceDiff > 0 ? `直降￥${priceDiff}, 冲榜成功再返现金` : '冲榜成功返现金';
    }
    if (priceDiff > 0) {
        return salesCount > 0 ? `已享直降￥${priceDiff}, 已售${getSaleCountStr(salesCount)}` : `已享直降￥${priceDiff}`;
    }
    if (salesCount > 0) {
        return `已售${getSaleCountStr(salesCount)}`;
    }
    return '热销中';
}
function getSaleCountStr(saleCount) {
    if (saleCount < 100) {
        return String(saleCount);
    }
    if (saleCount < 10000) {
        // 取整数部分 + '+'
        return `${Math.floor(saleCount / 100) * 100}+`;
    }
    // 大于等于10000，展示 x万+
    return `${(saleCount / 10000).toFixed(1)}万+`;
}
// 工具函数：获取链接
export function getSuperGroupUrl(pageType, params, userClientType) {
    // 确定客户端类型
    let clientType = userClientType !== null && userClientType !== void 0 ? userClientType : CLIENT_TYPE.MT_MRN;
    const platformType = getPlatformType();
    if (isDianpingAppOrWebview()) {
        clientType = CLIENT_TYPE.DP_MRN;
    }
    else if (platformType === PlatformType.mtHotelMinaWebview) {
        clientType = CLIENT_TYPE.HOTEL_MINIAPP;
    }
    else if (platformType === PlatformType.mtMinaWebview) {
        clientType = CLIENT_TYPE.MT_MINIAPP;
    }
    // 获取基础URL并替换参数
    let url = SUPER_GROUP_URL_TEMPLATE[clientType][pageType];
    Object.entries(params).forEach(([key, value]) => {
        url = url.replace(`{${key}}`, value || '');
    });
    // 根据平台类型返回最终URL
    if (platformType === PlatformType.mtHotelMinaWebview && pageType !== SUPER_GROUP_PAGE.GOODS_DETAIL) {
        return `/pages/h5/index?q=${encodeURIComponent(url)}`;
    }
    if (platformType === PlatformType.mtMinaWebview && pageType !== SUPER_GROUP_PAGE.GOODS_DETAIL) {
        return `/hotel/pages/h5?q=${encodeURIComponent(url)}`;
    }
    return url;
}
export function createFeSuperGroupGoodsList(beResponse, feConfig) {
    var _a, _b;
    const result = [];
    try {
        (_b = (_a = beResponse === null || beResponse === void 0 ? void 0 : beResponse.data) === null || _a === void 0 ? void 0 : _a.list) === null || _b === void 0 ? void 0 : _b.forEach(beCrossGoods => {
            var _a, _b, _c;
            const { productIdStr, title, headImage, giftList, priceModel, salesCount: rawSaleCount = '0', extModel, score, rating, recommendReason, tagModelList = [] } = beCrossGoods;
            const salesCount = rawSaleCount !== null && rawSaleCount !== void 0 ? rawSaleCount : '0';
            const { gmvProcess, gmv, targetGMV, targetOrderCnt, mboxCouponId } = extModel;
            const { originalPrice, sellPrice, discountInfo } = priceModel !== null && priceModel !== void 0 ? priceModel : {};
            // 超团榜单都按爆品的形式展示
            const isSpuHot = true;
            const bottomTagImgSource = getRealImageSource(feConfig.tagImgSource);
            const feSuperGroupItem = {
                id: productIdStr,
                isMillion: isSpuHot,
                goodsDetailUrl: getSuperGroupUrl(SUPER_GROUP_PAGE.GOODS_DETAIL, {
                    mboxCouponId: mboxCouponId === null || mboxCouponId === void 0 ? void 0 : mboxCouponId.toString(),
                    spuId: productIdStr
                }),
                goodsImage: appendImageWidth(convertToHttps(headImage), 375).replace('/w.h/', '/'),
                goodsName: title,
                goodsScore: score !== null && score !== void 0 ? score : '',
                goodsReview: rating !== null && rating !== void 0 ? rating : '',
                goodsRecommendReason: recommendReason !== null && recommendReason !== void 0 ? recommendReason : '',
                goodsGiftList: giftList,
                goodsOriginalPrice: originalPrice,
                goodsSellPrice: sellPrice,
                goodsSales: parseInt(salesCount),
                gmvProcess: (_a = parseFloat(gmvProcess === null || gmvProcess === void 0 ? void 0 : gmvProcess.toFixed(2))) !== null && _a !== void 0 ? _a : 0,
                buttonExtraText: getExtraButtonText(isSpuHot, targetOrderCnt, parseInt(salesCount)),
                promotionText: getPromotionText(isSpuHot, parseInt((_b = priceModel.originalPrice) !== null && _b !== void 0 ? _b : '0'), parseInt((_c = priceModel.sellPrice) !== null && _c !== void 0 ? _c : '0'), parseInt(salesCount)),
                bottomTagImgSource,
                tagModelList,
                discountInfo
            };
            result.push(feSuperGroupItem);
        });
    }
    catch (e) { }
    finally {
        return result;
    }
}
